import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL || "";


const apiClient = axios.create();


apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const fetchGamesApi = async () => {
    // axios ki jagah apiClient use kiya
    const response = await apiClient.get(`${baseUrl}/api/games`);
    return response;
};

export const requestOtpApi = async (msisdn, ext_ref) => {
    const response = await apiClient.post(`${baseUrl}/api/request-otp`, { msisdn, ext_ref });
    return response;
};

export const verifyOtpApi = async (msisdn, referenceNo, otp, ext_ref) => {
    const response = await apiClient.post(`${baseUrl}/api/verify-otp`, {
        msisdn,
        referenceNo,
        otp,
        ext_ref
    });
    return response;
};

export const checkUserSubscriptionApi = async (msisdn) => {
    const response = await apiClient.post(`${baseUrl}/login/sub`, { 
        msisdn 
    });
    return response;
};

export const unsubscribeApi = async (msisdn, maskedId) => {
    const response = await apiClient.post(`${baseUrl}/api/unsubscribe`, { 
        msisdn, 
        maskedId 
    });
    return response;
};